import moment from 'moment';
import i18n from '../../i18n';

export default {
  playedAtDate(store) {
    return moment(store.form.playedAt).format('YYYY-MM-DD');
  },

  playedAtTime(store) {
    return moment(store.form.playedAt).format('HH:mm');
  },

  // #region Players

  availablePlayers(store, getters) {
    const ids = Object.keys(store.form.convocations).map(i => Number(i));

    function awayPlayerFilter(p) {
      const { status } = p.infos[0];

      return [2, 3].includes(status) || getters.homePlayerIds.includes(p.id);
    }

    if (ids.length === 0) return store.players.filter(awayPlayerFilter);

    return store.players
      .filter(awayPlayerFilter)
      .filter(p => ids.includes(p.id) && store.form.convocations[p.id] === true);
  },

  availablePlayerIds(store, getters) {
    return getters.availablePlayers.map(p => p.id);
  },

  availableHomePlayersObject(store, getters) {
    return getters.availablePlayers.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
  },

  selectedHomePlayers(store) {
    return Object.values(store.form.homePlayers).sort((a, b) => {
      let result = a.order - b.order;
      if (result === 0 && a.id && b.id) {
        result = a.id - b.id;
      }
      return result;
    });
  },

  homePlayerIds(store) {
    return Object.values(store.form.homePlayers).map(p => p.playerId);
  },

  selectedHomePlayerIds(store, getters) {
    return getters.selectedHomePlayers.map(p => p.playerId);
  },

  homePlayersSelectItems(store, getters) {
    return getters.availablePlayers.map(p => ({
      playerId: p.id,
      fullName: p.fullName,
      disabled:
        getters.selectedHomePlayerIds.includes(p.id) ||
        (p.infos[0].status !== null && (p.infos[0].status === 0 || p.infos[0].status === 1)),
      avatarUrls: p.avatarUrls,
      shirt: p.shirtNumber,
    }));
  },

  activeHomePlayers(store) {
    return Array.from({ length: store.form.players }, (i, k) => k + 1)
      .map(i => {
        if (store.form.homePlayers[i]) {
          return {
            text: store.form.homePlayers[i].fullName,
            value: store.form.homePlayers[i].playerId,
            order: i,
          };
        }

        return null;
      })
      .filter(Boolean);
  },

  activeHomePlayersForHomeModule(store) {
    return Object.values(store.form.homePlayers)
      .map(player => ({
        text: player.fullName,
        value: player.playerId,
        order: player.order,
        disabled:
          Object.values(store.form.homeModule.players).find(p => p.value === player.playerId) !==
          undefined,
      }))
      .filter(p => p.order !== 0);
  },

  activeHomePlayersForHomeModule2(store) {
    return Object.values(store.form.homePlayers)
      .map(player => ({
        text: player.fullName,
        value: player.playerId,
        order: player.order,
        disabled:
          Object.values(store.form.homeModule2.players).find(p => p.value === player.playerId) !==
          undefined,
      }))
      .filter(p => p.order !== 0);
  },

  playingHomePlayers(store) {
    const enteringMatchPlayerIds = store.form.homeSubstitutions
      .filter(s => s.enteringMatchPlayerId > store.form.players)
      .map(s => s.enteringMatchPlayerId);

    return Object.entries(store.form.homePlayers).reduce((acc, [k, player]) => {
      const order = Number(k);

      if (order !== 0 && (order <= store.form.players || enteringMatchPlayerIds.includes(order))) {
        acc.push(player);
      }

      return acc;
    }, []);
  },

  activeOpponentPlayers(store) {
    return Array.from({ length: store.form.players }, (i, k) => k + 1)
      .map(i => {
        if (store.form.opponentPlayers[i]) {
          return {
            text: store.form.opponentPlayers[i].name,
            order: i,
            value: i,
          };
        }

        return null;
      })
      .filter(Boolean);
  },

  activeOpponentPlayersForOpponentModule(store) {
    return Object.values(store.form.opponentPlayers)
      .map(player => ({
        text: player.name || i18n.t('common.unknownPlayer'),
        value: player.order,
        order: player.order,
        disabled:
          Object.values(store.form.opponentModule.players).find(p => p.order === player.order) !==
          undefined,
      }))
      .filter(p => p.order !== 0);
  },

  // #endregion

  formationsForSelect(store) {
    return store.formations
      .filter(item => item.players === store.form.players)
      .map(item => ({
        text: item.name,
        value: item,
      }));
  },
};



// WEBPACK FOOTER //
// ./src/store/matches/getters.js